import React, { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../components/sidebar";
import Notification from "../components/Notification";
import ProfileDropdown from "../components/ProfileDropdown";
import "../styles/Dashboard.css";  // 🔹 Styling global
import "../styles/TotalPendapatan.css";  // 🔹 Styling khusus halaman ini
import { Chart } from "react-google-charts";

const TotalPendapatan = () => {
    const [data, setData] = useState([]);
    const [salesTotal, setSalesTotal] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [hargaPerGalon, setHargaPerGalon] = useState(6000);

    // Ambil username & token dari localStorage
    const username = localStorage.getItem("username");
    const token = localStorage.getItem("token");

    useEffect(() => {
        if (!username || !token) {
            console.warn("🚨 Tidak ada username atau token. Redirect ke login.");
            window.location.href = "/login";
            return;
        }

        const fetchData = async () => {
            try {
                console.log("🔍 Fetching data from API...");

                // 🔹 Ambil data pendapatan berdasarkan jumlah galon
                const resPendapatan = await axios.get(`https://depotaircerdas.com/api/pendapatan/${username}`, {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json",
                    }
                });

                console.log("✅ API Response (Pendapatan dari Galon):", resPendapatan.data);
                setData(Array.isArray(resPendapatan.data.data) ? resPendapatan.data.data : []);


                // 🔹 Ambil data total pendapatan dari sales-total API
                const resSalesTotal = await axios.get(`https://depotaircerdas.com/api/sales/total/${username}`, {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json",
                    }
                });

                console.log("✅ API Response (Total Sales Pendapatan):", resSalesTotal.data);
                setSalesTotal(resSalesTotal.data.total_pendapatan || 0);

                setError(null);
            } catch (error) {
                console.error("❌ Error fetching data:", error.response ? error.response.data : error.message);
                setError("Gagal mengambil data: " + (error.response ? error.response.data.message : error.message));
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [username, token]);

    return (
        <div className="total-pendapatan-container">
            {/* 🔹 Header Sama seperti Dashboard */}
            <div className="dashboard-header">
                <div className="header-title">
                    <h2>Total Pendapatan</h2>
                </div>
                <div className="header-right">
                    <Notification username={username} />
                    <ProfileDropdown username={username} />
                </div>
            </div>        

            <Sidebar />

            <div className="total-pendapatan-content">
                {/* 🔹 Tampilkan Total Pendapatan dari Galon yang Terjual */}
                <h3>Total Pendapatan Berdasarkan Galon</h3>
                <p className="pendapatan-value">
                {new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(
                    Array.isArray(data) 
                    ? data.reduce((sum, d) => sum + d.gallons * hargaPerGalon, 0)
                    : 0
                )}
                </p>


                {/* 🔹 Tampilkan Total Pendapatan dari Penjualan (sales-total) */}
                <h3>Pendapatan dari Penjualan</h3>
                <p className="pendapatan-value">
                    {new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(salesTotal)}
                </p>

                {/* 🔹 Input untuk harga per galon */}
                <div className="input-group">
                    <label>Harga per Galon (Rp): </label>
                    <input
                        type="number"
                        value={hargaPerGalon}
                        onChange={(e) => setHargaPerGalon(Number(e.target.value))}
                    />
                </div>

                {loading ? (
                    <p>Loading...</p>
                ) : error ? (
                    <p style={{ color: "red", fontWeight: "bold" }}>{error}</p>
                ) : (
                    <>
                        {data.length > 0 && (
                            <Chart
                                chartType="ColumnChart"
                                data={[
                                    ["Periode", "Pendapatan"], 
                                    ...(Array.isArray(data) ? data : []).map(d => [d.periode.split("T")[0], d.gallons * hargaPerGalon])

                                ]} 
                                width="100%"
                                height="300px"
                                options={{
                                    title: "Total Pendapatan per Periode",
                                    legend: { position: "top" },
                                    hAxis: { title: "Periode" },
                                    vAxis: { 
                                        title: "Pendapatan (IDR)", 
                                        gridlines: { count: 5 } 
                                    },
                                }}
                            />
                        )}

                        {/* 🔹 Tabel Pendapatan */}
                        <table className="total-pendapatan-table">
                            <thead>
                                <tr>
                                    <th>Periode</th>
                                    <th>Jumlah Galon</th>
                                    <th>Pendapatan (Rp)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.periode.split("T")[0]}</td>  
                                        <td>{item.gallons}</td>
                                        <td>{new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(item.gallons * hargaPerGalon)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </>
                )}
            </div>
        </div>
    );
};

export default TotalPendapatan;
